import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';
import './channels';
import { store } from './store';
import { Provider } from 'react-redux';

document.addEventListener('DOMContentLoaded', () => {

  const container = document.getElementById('root');
  if (container) {
    const root = createRoot(container);
    root.render(
      <Provider store = {store}> 
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    );
  }
});
